export const OFFLINE_DB_NAME = 'vela-offline-queue';
export const OFFLINE_DB_VERSION = 4;
export const OFFLINE_KEY_STORE = 'keys';
export const OFFLINE_REQUEST_STORE = 'requests';

// The legacy queue and encryption key share one database. Every opener must
// apply the complete schema; otherwise whichever module opens a fresh database
// first can leave the other module's store permanently missing at that version.
export function openOfflineDb() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(OFFLINE_DB_NAME, OFFLINE_DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(OFFLINE_KEY_STORE)) {
        db.createObjectStore(OFFLINE_KEY_STORE, { keyPath: 'id' });
      }
      if (!db.objectStoreNames.contains(OFFLINE_REQUEST_STORE)) {
        const store = db.createObjectStore(OFFLINE_REQUEST_STORE, { keyPath: 'id' });
        store.createIndex('createdAt', 'createdAt', { unique: false });
      }
    };
    request.onsuccess = () => {
      const db = request.result;
      db.onversionchange = () => db.close();
      resolve(db);
    };
    request.onerror = () => reject(request.error);
    request.onblocked = () => reject(new Error('Offline storage upgrade is blocked. Close other Sena tabs and try again.'));
  });
}
